import * as yup from 'yup';
import { qualificationInputWithAddressValidationSchema } from '../../validation';

export const guestUserQualificationCreateValidationSchema = qualificationInputWithAddressValidationSchema.concat(
  yup.object({
    full_name: yup.string().required('Please enter your full name'),
    email: yup.string().required('Please enter your email address').email('Please enter a valid email address'),
    phone: yup.string().required('Please enter your phone number'),
  })
);
